import { c as _c } from "react/compiler-runtime";
import classNames from '@/utils/classNames';
import type { ModalHeaderProps } from './Modal.types';
const baseClassName = ['text-greyscale-900', 'font-normal', 'flex', 'flex-col', 'group-[.sm]/modal:rounded-t-lg', 'group-[.sm]/modal:px-8', 'group-[.sm]/modal:gap-y-2', 'group-[.md]/modal:rounded-t-2xl', 'group-[.md]/modal:px-9', 'group-[.md]/modal:py-6', 'group-[.md]/modal:bg-stone-50', 'group-[.mr-0]/modal:bg-stone-50', 'group-[.drawer]/modal:px-8', 'group-[.drawer]/modal:drop-shadow-sm', 'group-[.lg]/modal:pb-6', 'group-[.full]/modal:pb-6'];
const Header = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames(baseClassName, className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <header className={t1} {...props}>{children}</header>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default Header;